import {
    GET_WALLET_SUMMARY_REQUEST,
    GET_WALLET_SUMMARY_SUCCESS,
    GET_WALLET_SUMMARY_FAILURE
} from "../ActionTypes/ActionTypes.js";
const initialState = {
    loading: false,
    error: null,

    assets: {},

    totalCryptoQuantity: 0,
    totalCryptoBalanceINR: 0,
    totalCryptoBalanceUSDT: 0,
    totalInvestmentINR: 0,
    totalInvestedUSDT: 0,
    totalInvestedINR: 0,
    totalInvestedUSD: 0,
    totalProfitINR: 0,
    totalProfit: 0,
    totalLossINR: 0,
    totalPnL: 0,
    todaysPnl: 0,
    yesterdayPnl: 0,
    currentMonthPNL: 0,
    currentMonthPNLPercentage: 0,
    currentMonthProfitINR: 0,
    currentMonthProfitUSDT: 0,
    lastMonthProfitINR: 0,
    lastMonthProfitUSDT: 0,
    monthChangePercent: 0
};

export default function walletReducer(state = initialState, action) {
    switch (action.type) {

        case GET_WALLET_SUMMARY_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_WALLET_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                assets: action.payload.assets,
                totalCryptoQuantity: action.payload.totalCryptoQuantity,
                totalCryptoBalanceINR: action.payload.totalCryptoBalanceINR,
                totalCryptoBalanceUSDT: action?.payload?.totalCryptoBalanceUSDT,
                totalCryptoBalanceUSD: action?.payload?.totalCryptoBalanceUSD,
                lastMonthPNL: action?.payload?.lastMonthPNL,
                totalInvestmentINR: action.payload.totalInvestmentINR,
                totalInvestedUSDT: action?.payload?.totalInvestedUSDT,
                todaysPnl: action?.payload?.todaysPnl,
                todaysPnlPercentage: action?.payload?.todaysPnlPercentage,
                yesterdayPnl: action?.payload?.yesterdayPnl,
                totalInvestedINR: action.payload.totalInvestedINR,
                totalInvestedUSD: action?.payload?.totalInvestedUSD,
                totalProfitINR: action.payload.totalProfitINR,
                totalProfit: action?.payload?.totalProfit,
                totalLossINR: action.payload.totalLossINR,
                totalPnL: action.payload.totalPnL,
                currentMonthPNL: action?.payload?.currentMonthPNL,
                currentMonthProfitINR: action?.payload?.currentMonthProfitINR,
                currentMonthPNLPercentage: action?.payload?.currentMonthPNLPercentage,
                currentMonthProfitUSDT: action?.payload?.currentmonthProfitUSDT,
                lastMonthProfitINR: action?.payload?.lastMonthProfitINR,
                lastMonthProfitUSDT: action?.payload?.lastMonthProfitUSDT,
                monthChangePercent: action?.payload?.monthChangePercent
            };

        case GET_WALLET_SUMMARY_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}